import { type FC } from 'react'

import useFeedbackPrompt from '../../hooks/useFeedbackPrompt/useFeedbackPrompt'
import FeedbackSnackbar from './FeedbackSnackbar'
import { type NotificationViewProps } from './types'

// VIEWS is typed on NotificationViewProps, which carries no onAnswer. This
// adapter supplies it from the hook so FeedbackSnackbar stays presentational
// and testable without a store.
const FeedbackSnackbarView: FC<NotificationViewProps> = (props) => {
  const { answer } = useFeedbackPrompt()

  return <FeedbackSnackbar {...props} onAnswer={answer} />
}

export default FeedbackSnackbarView
